import useWidth from '@components/Hooks/useWidth';
import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import { ReactElement } from 'react';
import { OrderTargetSummary } from '../../orderObjectTargetsTab.types';
import OrderTargetSummaryCard from './components/OrderTargetSummaryCard';
import OrderTargetSummaryLoading from './components/OrderTargetSummaryLoading';
import useOrderTargetSummary from './hooks/useOrderTargetSummary';

interface OrderTargetSummaryTooltipProps {
  summary: OrderTargetSummary | undefined;
  onOpen: () => void;
  children: ReactElement;
}

const OrderTargetSummaryTooltip = ({
  summary,
  onOpen,
  children,
}: OrderTargetSummaryTooltipProps) => {
  const view = useOrderTargetSummary(summary);
  const { mobileWidth } = useWidth();

  return (
    <Tooltip
      interactive
      anchorToCursor
      fullWidth
      disabled={mobileWidth}
      placement="bottom-left"
      TooltipContent={
        view ? (
          <OrderTargetSummaryCard summary={view} />
        ) : (
          <OrderTargetSummaryLoading onOpen={onOpen} />
        )
      }
    >
      {children}
    </Tooltip>
  );
};

export default OrderTargetSummaryTooltip;
